import React from "react";
import styled from "styled-components";
import Page from "../components/Page";
import { useLang } from "../i18n/LanguageContext";
import usePageMeta from "../hooks/usePageMeta";

// TODO (Amiri): replace these with your real support details.
const CONTACT = {
  email: "hello@amoraweddings.com",
  whatsapp: "38344000000", // international format, no +
  instagram: "amoraweddings",
};

export default function Contact() {
  const { lang } = useLang();
  const sq = lang === "sq";
  usePageMeta(sq ? "Kontakt — Amora Weddings" : "Contact — Amora Weddings");

  return (
    <Page
      title={sq ? "Na kontakto" : "Get in touch"}
      subtitle={
        sq
          ? "Ke pyetje për listimin, pagesën ose platformën? Jemi këtu."
          : "Questions about your listing, payment or the platform? We're here."
      }
      narrow
    >
      <Channels>
        <a className="primary" href={`mailto:${CONTACT.email}`}>
          ✉ {CONTACT.email}
        </a>
        <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer">
          WhatsApp
        </a>
        <a href={`https://instagram.com/${CONTACT.instagram}`} target="_blank" rel="noreferrer">
          Instagram
        </a>
      </Channels>

      <Note>
        {sq
          ? "Përgjigjemi zakonisht brenda 24 orëve. Për çështje pagese ose aktivizimi, shkruaj nga e njëjta email-adresë që përdore gjatë regjistrimit."
          : "We usually reply within 24 hours. For payment or activation issues, write from the same email you used during registration."}
      </Note>
    </Page>
  );
}

const Channels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 420px;
  margin: 0 auto;
  a {
    text-align: center;
    text-decoration: none;
    border: 1px solid ${({ theme }) => theme.colors.hair};
    border-radius: 100px;
    padding: 15px 24px;
    font-size: 15px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.ink};
    transition: 0.2s;
    &:hover { border-color: ${({ theme }) => theme.colors.green}; }
    &.primary { background: ${({ theme }) => theme.colors.green}; color: ${({ theme }) => theme.colors.cream}; border-color: ${({ theme }) => theme.colors.green}; }
  }
`;

const Note = styled.p`
  margin: 28px auto 0;
  max-width: 460px;
  text-align: center;
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: 14px;
  line-height: 1.6;
`;
